import swal from "sweetalert2";
import store from "../store";

export default {
  now() {
    let date = new Date();
    let year = date.getFullYear();
    let month =
      (date.getMonth() + 1).length === 1
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    let day =
      date.getDate().length === 1 ? "0" + date.getDate() : date.getDate();

    let hour =
      date.getHours().length === 1 ? "0" + date.getHours() : date.getHours();
    let minutes =
      date.getMinutes().length === 1 ? "0" + date.getHours() : date.getHours();
    let seconds =
      date.getSeconds().length === 1
        ? "0" + date.getSeconds()
        : date.getSeconds();

    return (
      year +
      "-" +
      month +
      "-" +
      day +
      " " +
      hour +
      ":" +
      minutes +
      ":" +
      seconds
    );
  },
  successAlert(text, title = "Success", confirmButtonText = "OK") {
    return swal({
      title: title,
      text: text,
      type: "success",
      showConfirmButton: true,
      confirmButtonText: confirmButtonText,
      allowOutsideClick: false,
      allowEscapeKey: false
    });
  },
  errorAlert(text, title = "Error", confirmButtonText = "Close") {
    return swal({
      title: title,
      text: text,
      type: "error",
      showConfirmButton: true,
      confirmButtonText: confirmButtonText,
      allowOutsideClick: false,
      allowEscapeKey: false
    });
  },
  infoAlert(text, title = "Info", confirmButtonText = "OK") {
    return swal({
      title: title,
      text: text,
      type: "info",
      showConfirmButton: true,
      confirmButtonText: confirmButtonText,
      allowOutsideClick: false,
      allowEscapeKey: false
    });
  },
  warningAlert(text, title = "Info", confirmButtonText = "OK") {
    return swal({
      title: title,
      text: text,
      type: "warning",
      showConfirmButton: true,
      confirmButtonText: confirmButtonText,
      allowOutsideClick: false,
      allowEscapeKey: false
    });
  },
  questionAlert(text, title = "Question", confirmButtonText = "Yes") {
    return swal({
      title: title,
      text: text,
      type: "question",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: confirmButtonText,
      allowOutsideClick: false,
      allowEscapeKey: false
    });
  },
  formatNumber(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  },
  loading(status) {
    store.commit("SET_LOADING", status);
    store.commit("SET_ERROR", { show: false, message: "" });
    store.commit("SET_INFO", { show: false, message: "" });
  },
  info(content) {
    store.commit("SET_INFO", content);
    store.commit("SET_LOADING", false);
    store.commit("SET_ERROR", { show: false, message: "" });
  },
  error(content) {
    store.commit("SET_ERROR", content);
    store.commit("SET_INFO", { show: false, message: "" });
    store.commit("SET_LOADING", false);
  },
  getModuleId(name) {
    let modules = [];
    if (store.state.services) {
      modules = store.state.services;
    } else if (window.localStorage.getItem("services")) {
      modules = JSON.parse(window.localStorage.getItem("services"));
    }
    return modules.find(function(element) {
      return element.name === name;
    });
  },
  resetItems() {
    // Reset the menu
    store.commit("SET_SERVICES", null);
    if (window.localStorage) {
      window.localStorage.removeItem("services");
    }
    // Reset the county
    store.commit("SET_ACTIVE_COUNTY", {});
    if (window.localStorage) {
      window.localStorage.removeItem("activeCounty");
    }
  },
  randomNumber(length) {
    let digits = "";
    for (let i = 0; i < length; i++) {
      digits += Math.floor(Math.random() * 10);
    }
    return digits;
  }
};



// WEBPACK FOOTER //
// ./src/helpers/index.js